import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element: Component, allowedRoles }) => {
    const isAuthenticated = !!localStorage.getItem('token');
    const userRole = localStorage.getItem('role');

    if (!isAuthenticated) {
        // If user is not authenticated, redirect them to the login page
        return <Navigate to="/login" replace />;
    }

    // If the route has specific roles and the user's role is not included,
    // redirect them to an 'unauthorized' page.
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // If the user is authenticated and has the correct role, render the component.
    return Component;
};

export default ProtectedRoute;
